import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="mx-auto flex w-full max-w-content flex-col items-center gap-5 px-4 py-28 text-center md:px-6">
      <span className="font-heading text-6xl font-bold text-primary-500">404</span>
      <h1 className="font-heading text-2xl font-bold text-foreground-950">这个页面不在档案里</h1>
      <p className="max-w-md font-body text-sm text-foreground-600">
        你要找的内容可能已经被重新归档。回到首页，继续看今天整理好的爆料片段吧。
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-label text-background-50 transition-colors hover:bg-primary-600"
      >
        <i className="ri-home-4-line" />
        返回首页
      </Link>
    </section>
  );
}